/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForScheduleRecommendation extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForScheduleRecommendation");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForScheduleRecommendation.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForScheduleRecommendation>): BackgroundJobPayloadForScheduleRecommendation {
        let obj = Object.assign(new BackgroundJobPayloadForScheduleRecommendation(), model);
        BackgroundJobPayloadForScheduleRecommendation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForScheduleRecommendation>): BackgroundJobPayloadForScheduleRecommendation {
        if (!model) return null;
        return BackgroundJobPayloadForScheduleRecommendation.newInstance(<BackgroundJobPayloadForScheduleRecommendation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForScheduleRecommendation) {
        if (!obj) return;

        models.BackgroundJobPayloadForScheduleRecommendation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForScheduleRecommendation): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForScheduleRecommendation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service Account Id on which to generate schedule recommendations
     */
    service_account_id: string;

}
